import ExportCsvIcon from "@/Common/_images/ExportCsv.svg";

interface IPrintButtonProps {
    className?: string;
    onClick: () => void;
}

function ExportCsvButton(props: IPrintButtonProps): JSX.Element {
    let className = "button control push-right-5";

    if (props.className)
        className += ` ${props.className}`;

    const handleClick = (event: React.MouseEvent): void => {
        event.stopPropagation();
        props.onClick();
    };

    return (
        <button
            className={className}
            onClick={(event: React.MouseEvent) => handleClick(event)}
        >
            <ExportCsvIcon />
        </button>
    );
}

export { ExportCsvButton };
